export default "__VITE_ASSET__Dhpk3Ujt__"